import { post } from '../../app/services/http';

export default function makeBookings() {
  const url = '/rest/v1/payments/book';
  const headers = { 'Content-Type': 'application/json' };
  const body = { };
  return post({
    url,
    headers,
    body,
  });
}
